import {API_MODULES, API_ROUTES, API_SOLUTIONS, ApiRoute} from "@api/ApiRoutes";
import {Redemption, RedemptionFilters, RedemptionStatusEnum} from "@lib/Redemption/RedemptionModels";
import {generateApiEndpoint} from "@api/ApiUtils";
import {getRequest} from "@api/ApiService";
import {ApiException} from "@/exceptions/ApiException";

const ROUTES: Record<string, ApiRoute> = {
    GET_REDEMPTIONS: {
        path: API_ROUTES.GET_REDEMPTIONS,
        module: API_MODULES.SOLUTION,
        solution: API_SOLUTIONS.MZ
    },
    GET_REDEMPTION_DETAILS: {
        path: API_ROUTES.GET_REDEMPTION_DETAILS,
        module: API_MODULES.SOLUTION,
        solution: API_SOLUTIONS.MZ
    }
}

class RedemptionService {

    static getRedemptions = async (filters: RedemptionFilters): Promise<Redemption[]> => {
        const url = generateApiEndpoint(ROUTES.GET_REDEMPTIONS);

        const params = new URLSearchParams();

        Object.entries(filters ?? {}).forEach(([key, value]) => {
            params.append(key, value);
        });

        return await getRequest<Redemption[]>(`${url}?${params.toString()}`);
    }

    static getRedemptionDetails = async (redemptionLogicId: string, retryOnStatusInserted: boolean = false): Promise<Redemption> => {

        const url = generateApiEndpoint({
            ...ROUTES.GET_REDEMPTION_DETAILS,
            params: {
                redemptionLogicId
            }
        });

        const redemption = await getRequest<Redemption>(url);

        if (retryOnStatusInserted && redemption.status === RedemptionStatusEnum.INSERTED) {
            throw new ApiException("REDEMPTION_STATUS_INSERTED", "REDEMPTION_STATUS_INSERTED", 404);
        }

        return redemption

    }

}

export default RedemptionService;